import {AfterViewInit, Component, OnInit, Input, ViewChild, forwardRef} from '@angular/core';
import {FrtBillOfLadingService} from '../frt-bill-of-lading/frt-bill-of-lading.service';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import {ActivatedRoute} from '@angular/router';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS
} from '@angular/forms';
import {tap} from 'rxjs/operators';

@Component({
    selector: 'app-frt-billoflading-finalization',
    templateUrl: './frt-billoflading-finalization.component.html',
    styleUrls: ['./frt-billoflading-finalization.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FRTBillofladingFinalizationComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => FRTBillofladingFinalizationComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class FRTBillofladingFinalizationComponent implements ControlValueAccessor, OnInit {
  frtBolFinalizationForm: UntypedFormGroup;
  bolCorrectionInfo: any = {};
  @Input() totalCost: number;
  @Input() additionalRemarks: string;
  @Input() billOfLadingNbr: string;
  finalization$ = this.frtBillOfLadingService.frtBolFinalizationDetails$
    .pipe(tap(finalizationDetail => {
      this.bolCorrectionInfo = finalizationDetail;
      this.frtBolFinalizationForm.patchValue(finalizationDetail, {emitEvent: true});
      this.frtBolFinalizationForm.patchValue({additionalRemarks: this.additionalRemarks});
    }));

  constructor(private fb: UntypedFormBuilder, private loader: LoadingService, private alertService: AlertService,
              private route: ActivatedRoute, private frtBillOfLadingService: FrtBillOfLadingService) {
  }

  /**
   * @description creates finalization form.
   */
  ngOnInit() {
    this.createForm();
    this.frtBolFinalizationForm.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }

  /**
   * @description intializes all the form controls
   */
  createForm() {
    this.frtBolFinalizationForm = this.fb.group({
      // totalEstimatedCharges: new FormControl(''),
      bolCorrectionNoticeId: new UntypedFormControl(''),
      additionalRemarks: new UntypedFormControl(''),
      billOfLadingNbr: new UntypedFormControl(''),
      correctionRemarks: new UntypedFormControl(''),
      authorityForCorrection: new UntypedFormControl('')
    });
  }

  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  get value(): any {
    return this.frtBolFinalizationForm.value;
  }

  set value(value: any) {
    this.frtBolFinalizationForm.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value: any) {
    if (value) {
      this.value = value;
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(_: UntypedFormControl) {
    return this.frtBolFinalizationForm.valid ? null : {profile: {valid: false}};
  }
}
